import React from 'react';
import {
  Box,
  Paper,
  TextField,
  Button,
  Grid,
  Chip,
  IconButton,
  Typography
} from '@mui/material';
import {
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
  SettingsEthernetOutlined as TestTubeIcon,
  CheckCircle as CheckCircleIcon,
  Error as ErrorIcon,
  Inventory2Outlined as Inventory2OutlinedIcon
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const PacsDatabase = ({ 
  pacsDbSettings, 
  setPacsDbSettings, 
  testResults,
  loading,
  showPassword,
  setShowPassword,
  testPacsDatabase,
  savePacsSettings
}) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Inventory2OutlinedIcon color="primary" />
        {t('admin.serverManagement.pacsSettings')}
      </Typography>
      
      <Paper sx={{ p: 3 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label={t('admin.serverManagement.host')}
              value={pacsDbSettings.host}
              onChange={(e) => setPacsDbSettings(prev => ({ ...prev, host: e.target.value }))}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label={t('admin.serverManagement.port')}
              value={pacsDbSettings.port}
              onChange={(e) => setPacsDbSettings(prev => ({ ...prev, port: e.target.value }))}
              placeholder="3306"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label={t('admin.serverManagement.database')}
              value={pacsDbSettings.database}
              onChange={(e) => setPacsDbSettings(prev => ({ ...prev, database: e.target.value }))}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label={t('admin.serverManagement.username')}
              value={pacsDbSettings.username}
              onChange={(e) => setPacsDbSettings(prev => ({ ...prev, username: e.target.value }))}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label={t('admin.serverManagement.password')}
              type={showPassword ? 'text' : 'password'}
              value={pacsDbSettings.password}
              onChange={(e) => setPacsDbSettings(prev => ({ ...prev, password: e.target.value }))}
              InputProps={{
                endAdornment: (
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                  </IconButton>
                )
              }}
            />
          </Grid>
        </Grid>
        
        <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
          <Button
            variant="contained"
            onClick={testPacsDatabase}
            disabled={loading}
            startIcon={<TestTubeIcon />}
            className="button"
          >
            {t('admin.serverManagement.testConnection')}
          </Button>
          <Button
            variant="outlined"
            onClick={savePacsSettings}
            disabled={loading}
            className="button"
          >
            {t('admin.serverManagement.save')}
          </Button>
        </Box>
        
        {testResults.pacsDb && (
          <Chip
            icon={testResults.pacsDb.success ? <CheckCircleIcon /> : <ErrorIcon />}
            label={testResults.pacsDb.message}
            color={testResults.pacsDb.success ? 'success' : 'error'}
            sx={{ mt: 2 }}
          />
        )}
      </Paper>
    </Box>
  );
};

export default PacsDatabase; 